"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pro = Pro;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _link = _interopRequireDefault(require("@ux/link"));
var _enums = require("./enums");
function Pro(_ref) {
  let {
    loggedIn,
    proshopper,
    eids,
    urlArgs,
    urls,
    pcx
  } = _ref;
  if (!loggedIn || !proshopper) {
    return null;
  }
  if (proshopper && pcx) {
    return /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      className: "customer-link",
      "data-eid": eids.myHub,
      urlArgs: urlArgs
    }, urls.proHub), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.myHub
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
    className: "customer-link",
    urlArgs: urlArgs
  }, urls.proHomeApp, {
    "data-eid": eids.pro
  }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _enums.golf.pro
  }));
}
Pro.propTypes = {
  eids: _propTypes.default.object,
  loggedIn: _propTypes.default.bool,
  proshopper: _propTypes.default.bool,
  urlArgs: _propTypes.default.any,
  urls: _propTypes.default.object,
  pcx: _propTypes.default.bool
};
var _default = Pro;
exports.default = _default;